import Vue from 'vue'

export default {

  state: Vue.observable({
    bins: [],
  }),
  
  setBins(bins) {
    this.state.bins = bins
  },

  // updateClient(newclient) {
  //   this.state.bins = this.state.bins.map(client => {
  //     return client.id == newclient.id ? newclient : client
  //   })
  // },
}
